import styled from 'styled-components';
import { COLORS } from '../../styles/variables';

export const SortByWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${COLORS.grey80};
  width: 294px;
`;
export const Label = styled.p`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey80};
`;
export const SortSelector = styled.select`
  background: inherit;
  border: none;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;
export const Option = styled.option``;
